import React from "react";
import useJalaliLocaleListener from "./jalali-locale-listener-hook";

const JalaliLocaleListener = () => {
  useJalaliLocaleListener();
  return <></>;
};

export default JalaliLocaleListener;
